import React, { FC, useState } from "react";
import Dialog from "../../dialog";
import {
  Container,
  HeadWrapper,
  BodyModal,
  Icon,
} from './styles'
import { icons } from "../../../icons";
import Typography from "../../typography";
import Button from "../../button";
import { useTranslation } from "react-i18next";
import { HeadLine3 } from "../../typography/styled";

            
type ModalProps = {
  closeModalCancel:() => void;
  closeModal:() => void;
  alertTitle?:any;
  alertSubTitle?:any;
  confirmButtonText?:any;
  cancelButtonText?:any;
  loading?:boolean;
  loadingComplete?:boolean;
}  

const UniversalModal:FC<ModalProps> = (props) => {
  const {
    closeModal,
    closeModalCancel,
    alertTitle,
    alertSubTitle,
    loading,
    loadingComplete,
    confirmButtonText,
    cancelButtonText,
  } = props
  const [t] = useTranslation()

  return(
    <Container>
      <HeadWrapper>
        <HeadLine3 style={{marginLeft:'10px', marginTop:'10px'}}>
          {alertTitle}
        </HeadLine3>
        <Icon onClick={closeModalCancel} src={icons.CloseIcon}/>
      </HeadWrapper>
      <BodyModal>
        <Typography variant="body">{alertSubTitle}</Typography>
        <div style={{display:"flex", gap:'6px', marginTop:'30px'}}>
          <Button
            variant="stroke"
            size="display"
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={closeModalCancel}
            title={confirmButtonText || t("NO")}
          />
          <Button
            variant="primary"
            size="display"
            loading={loading}
            loadingComplete={loadingComplete}
            customStyles={{ width: '177px', justifyContent:'center' }}
            onClick={closeModal}
            title={cancelButtonText || t("YES")}
          />
        </div>
      </BodyModal>
    </Container>
  )
}

export default UniversalModal